import { Box, TextProps } from '@chakra-ui/react'
import { Label } from 'components/typography'
import { useIsMedlevePage } from 'hooks/helpers/useIsMedlevePage'
import { FC } from 'react'

interface NavbarLinkContainerProps extends TextProps {
  isActive?: boolean
  solidNavbar?: boolean
}

const NavbarLinkContainer: FC<NavbarLinkContainerProps> = ({ children, isActive, solidNavbar, ...rest }) => {
  const isMedleve = useIsMedlevePage()
  return (
    <Box alignItems="center" display="flex" position="relative">
      <Box color={solidNavbar ? 'phthalo' : 'alabaster'} {...rest}>
        {children}
        <Box
          display={isActive ? 'block' : 'none'}
          h="2px"
          bg={isMedleve ? 'medleve' : 'dandelion'}
          position="absolute"
          bottom="0"
        >
          <Box opacity="0">{children}</Box>
        </Box>
      </Box>
    </Box>
  )
}

export default NavbarLinkContainer
